import type { DresonRuleResolveEvent } from '@shared/types/Tilelist.ts';

const dresonRuleResolveTopic = 'ftfind.dresonRule.resolve';

type LegacyHistoryState = {
    events?: Record<string, unknown>;
};

/**
 *
 */
export function mergeLegacyHistoryState(event: DresonRuleResolveEvent, entryRule: string): void {
    const state: LegacyHistoryState = window.history.state ?? {};

    window.history.replaceState(
        {
            ...state,
            events: {
                ...state.events,
                [dresonRuleResolveTopic]: event,
            },
            entryRule,
        },
        '',
    );
}
